module.exports = __webpack_public_path__ + "static/media/Search.b3b7bd9a.svg";